import * as React from 'react';

import Formsy from 'formsy-react';
import PropTypes from 'prop-types';

import {Popover} from 'shells/popover/popover';

import {CheckmarkSubmitButton} from '../../base/form-components/checkmark-submit-button';
import {FormSelect} from '../../base/form-components/form-select';
import {FormTextField} from '../../base/form-components/form-textfield';
import getClassesMixin from '../../mixins/get-classes';

const baseSelectValues = [
    {id: 'Equals', name: 'Equals'},
    {id: 'Greater than', name: 'Greater than'},
    {id: 'Less than', name: 'Less than'},
];

export class NumberFormDeprecated extends React.Component {
    getClasses = getClassesMixin;

    static propTypes = {
        value: PropTypes.object,
        name: PropTypes.string,
        nullOptionText: PropTypes.string,
        onDirty: PropTypes.func,
        onSubmit: PropTypes.func,
        animateIn: PropTypes.bool,
    };

    static defaultProps = {
        value: {
            selected: 'Equals',
            data: '',
        },
    };

    constructor(props) {
        super(props);
        this.state = {
            canSubmit: false,
            selectValue: 'Equals',
        };
    }

    componentDidMount() {
        const timeoutDuration = this.props.animateIn ? 250 : 0;

        setTimeout(() => {
            if (this.focusMe) {
                this.focusMe.focus();
            }
        }, timeoutDuration);
    }

    render() {
        const {name, value, nullOptionText} = this.props;
        const selectValues = nullOptionText
            ? baseSelectValues.concat([{id: 'null', name: nullOptionText}])
            : baseSelectValues;

        return (
            <Formsy
                className='ui-form'
                onChange={(data, changed) => this.props.onDirty(changed)}
                onValidSubmit={(data) => this.props.onSubmit(data)}
                onValid={() => this.setState({canSubmit: true})}
                onInvalid={() => this.setState({canSubmit: false})}
            >
                <div className='ui-linked-select ui-linked-select__number-form'>
                    <FormSelect
                        name={`${name}.selected`}
                        styleOptions={{fullWidth: true}}
                        onChange={this.handleSelectValueChange}
                        value={value.selected}
                        selectValues={selectValues}
                    />
                    {this.state.selectValue !== 'null' ? (
                        <FormTextField
                            name={`${name}.data`}
                            formTextfieldRef={(c) => {
                                this.focusMe = c;
                            }}
                            value={value.data}
                            required={true}
                            validations='isNumeric'
                            type='number'
                        />
                    ) : undefined}
                </div>
                <CheckmarkSubmitButton
                    className='ui-popover__submit-button'
                    getButtonRef={(c) => {
                        this.submitButton = c;
                    }}
                    disabled={!this.state.canSubmit}
                    onMouseOver={() => this.setState({submitHover: true})}
                    onMouseOut={() => this.setState({submitHover: false})}
                />
                {this.state.submitHover && !this.state.canSubmit ? (
                    <Popover anchor={this.submitButton} bodyColor='error' isDialog={true}>
                        <span>Whoops! Input must be a number!</span>
                    </Popover>
                ) : undefined}
            </Formsy>
        );
    }

    handleSelectValueChange = (val) => {
        this.setState({selectValue: val});
    };
}
